import React from 'react'
import './AboutStyle.css'

export default function About() {
    return (
        <div className="aboutSection">

            <div className="container">
                <div className="about">
                    <h1 className="aboutTitle">WHO WE ARE</h1>
                    <h1 className="coompanyName">Company Name</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipite irure de eu fugiat nulla pariatur. consectetur adipite irure de eu fugiat nulla pariatur. consectetur adipite irure de eu fugiat nulla pariatur. Excepteur sint occaecat</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipite irure de eu fugiat nulla pariatur. consectetur adipite irure de eu fugiat nulla pariatur. consectetur adipite irure de eu fugiat nulla pariatur. Excepteur sint occaecat</p>
                </div>
            </div>
        </div>
    )
}
